import styled from 'styled-components';

/**
 * @component Container
 * @description Wrapper for invoice button
 */
export const Container = styled.div`
  display: inline-flex;
`;
